import {Component, ElementRef, Inject, OnInit} from '@angular/core';
import {ModalController, Platform} from '@ionic/angular';
import * as actionsUi from './mandantenverwaltung-technik.actions.ui';
import * as fromAuthModule from '@orga-app/auth/reducer';
import * as fromMandantModule from '@orga-app/mandant/reducer';
import * as fromMandantenverwaltungPage from './mandantenverwaltung-technik.reducer';
import {select, Store} from '@ngrx/store';
import {Observable} from 'rxjs';
import {DOCUMENT} from '@angular/common';
import {Settings, SettingsProvider} from '@orga-app/settings';
import {
    getAzureAdConfig,
    getSMTPConfig,
    getTroubleTicketConfig
} from './mandantenverwaltung-technik.selectors';
import {DomSanitizer, SafeUrl} from '@angular/platform-browser';
import {getTheme} from '@orga-app/settings/reducer';
import {UuidService} from '@orga-app/providers/uuid.service';
import {SmtpMandantOptions, TroubleTicketMandantOptions} from '../../../clients/kommunikation';
import {AzureAdMandantOptions} from '../../../clients/api';
import {JsonEditorPage} from '../modale/json-editor/json-editor.page';

declare let themesJson;

@Component({
    selector: 'page-mandantenverwaltung',
    templateUrl: './mandantenverwaltung-technik.page.html',
})
export class MandantenverwaltungTechnikPage implements OnInit {
    selectedTheme: Settings;
    public settings$: Observable<Settings>;
    themeDefault$: Observable<Settings>;
    logoHeaderSVG$: Observable<SafeUrl>;

    // UI
    technikTab = 'AAD';

    private aiName = 'MandantenverwaltungPage';
    private alive = true;

    public azureAdConfig$: Observable<AzureAdMandantOptions>;
    public smtpConfig$: Observable<SmtpMandantOptions>;
    public troubleTicketConfig$: Observable<TroubleTicketMandantOptions>;

    constructor(public modalCtrl: ModalController,
                private store: Store<fromMandantenverwaltungPage.PageState>,
                private storeAuth: Store<fromAuthModule.ModuleState>,
                private storeMandant: Store<fromMandantModule.ModuleState>,
                public platform: Platform,
                private settings: SettingsProvider,
                public settingsProvider: SettingsProvider,
                private uuid: UuidService,
                public element: ElementRef,
                private sanitizer: DomSanitizer,
                @Inject(DOCUMENT) private document: Document) {
        this.store.dispatch(new actionsUi.PageStateResetAction());

        this.themeDefault$ = this.settingsProvider.getThemeDefault();
        this.logoHeaderSVG$ = this.settingsProvider.getLogoHeaderSVG();
        this.settings$ = this.store.pipe(select(getTheme));
        this.settings.getActiveTheme().subscribe(val => this.selectedTheme = val);

        this.azureAdConfig$ = this.store.pipe(select(getAzureAdConfig));
        this.smtpConfig$ = this.store.pipe(select(getSMTPConfig));
        this.troubleTicketConfig$ = this.store.pipe(select(getTroubleTicketConfig));
    }

    ngOnInit() {
    }

    ionViewWillEnter() {
        this.store.dispatch(new actionsUi.PageStateResetAction());
    }

    azureAdConfigEingabe($event, config: AzureAdMandantOptions, propName: string, propTyp: string) {
        this.store.dispatch(new actionsUi.AzureAdConfigInput(this.dokumentAendernInput($event, config, propName, propTyp)));
    }

    smtpConfigEingabe($event, config: SmtpMandantOptions, propName: string, propTyp: string) {
        this.store.dispatch(new actionsUi.SmtpConfigInput(this.dokumentAendernInput($event, config, propName, propTyp)));
    }

    troubleTicketConfigEingabe($event, config: TroubleTicketMandantOptions, propName: string, propTyp: string) {
        this.store.dispatch(new actionsUi.TroubleTicketConfigInput(this.dokumentAendernInput($event, config, propName, propTyp)));
    }


    zugriffeSpeichern() {
        this.store.dispatch(new actionsUi.TechnischeZugriffeSpeichern());
    }

    dokumentAendernInput<T>($event, dokument: T, propName: string, propTyp: string): T {
        // console.log('event1: ', $event.detail);

        if (propName !== null) {
            if (propTyp === 'date') {
                // DATE
                dokument = Object.assign({}, dokument, {[propName]: this[propName]});
            } else if (propTyp === 'checkbox') {
                // Checkbox
                dokument = Object.assign({}, dokument, {[propName]: $event.detail.checked});
            } else if (propTyp === 'toggle') {
                // Toggle
                dokument = Object.assign({}, dokument, {[propName]: $event.detail.checked});
            } else if (propTyp === 'input') {
                // Input
                dokument = Object.assign({}, dokument, {[propName]: $event.target.value});
            } else if (propTyp === 'value') {
                // Value
                dokument = Object.assign({}, dokument, {[propName]: $event});
            } else {
                // SELECT
                dokument = Object.assign({}, dokument, {[propName]: $event.detail.value});
            }
        }

        return dokument;
    }

    async jsonEditorEmpfaengerOeffnen(object: TroubleTicketMandantOptions) {
        if (object != null && object != null) {
            const params = {
                json: JSON.stringify(object.recipients),
                untertitel: 'TroubleTicket-Empfänger'
            };
            const modal = await this.modalCtrl.create({component: JsonEditorPage, componentProps: params});
            modal.onDidDismiss().then((result: any) => {
                if (result != null && result.data) {
                    const config = Object.assign({}, object, {recipients: JSON.parse(result.data.json)});
                    this.store.dispatch(new actionsUi.TroubleTicketConfigInput(config));
                }
            });

            await modal.present();
        }
    }

    testMail() {
        this.store.dispatch(new actionsUi.SmtpTestmail());
    }

}
